<template>
  <div
    v-if="loading || !bundle.ready"
    class="flex flex-col gap-8"
  >
    <SkeletonLoader class="w-full h-96 rounded-3xl" />
    <SkeletonLoader class="w-full h-96 rounded-3xl" />
  </div>
  <div
    v-else
    class="flex flex-col gap-8"
  >
    <VarietyPackGridCard
      v-for="pack in packs"
      :key="pack.handle"
      :pack="pack"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useBundleStore, useVarietyPacksStore } from '@/stores'
import SkeletonLoader from '@/components/shared/v2/skeleton-loader.vue'
import VarietyPackGridCard from '@/components/variety-packs/variety-pack-grid-card.vue'

const bundle = useBundleStore()
const packsStore = useVarietyPacksStore()
const { varietyPacks, loading } = storeToRefs(packsStore)
const packs = computed(() => varietyPacks.value.filter(pack => pack.skuMap))

onMounted(packsStore.useVarietyPacks)
</script>
